export class KeyboardKeyHandler {
  private keys: KeyboardShortcut[];
  private actionWhenKeyDown: () => void;
  private actionWhenKeyUp: () => void;

  public onKeyDown = (keyboardEvent: KeyboardEvent) => {
    this.keys.forEach((key) => {
      if (
        key.key === keyboardEvent.key &&
        key.shift === keyboardEvent.shiftKey
      ) {
        this.actionWhenKeyDown();
        return;
      }
    });
  };

  public onKeyUp = (keyboardEvent: KeyboardEvent) => {
    this.keys.forEach((key) => {
      if (
        key.key === keyboardEvent.key &&
        key.shift === keyboardEvent.shiftKey
      ) {
        this.actionWhenKeyUp();
        return;
      }
    });
  };

  private constructor(
    shortcutKeys: KeyboardShortcut[],
    actionWhenKeyDown: () => void,
    actionWhenKeyUp: () => void
  ) {
    this.actionWhenKeyDown = actionWhenKeyDown;
    this.actionWhenKeyUp = actionWhenKeyUp;
    this.keys = shortcutKeys;
  }

  public static Create(
    shortcutKeys: KeyboardShortcut[],
    actionWhenKeyDown: () => void,
    actionWhenKeyUp: () => void
  ): KeyboardKeyHandler {
    return new KeyboardKeyHandler(
      shortcutKeys,
      actionWhenKeyDown,
      actionWhenKeyUp
    );
  }
}

export interface KeyboardShortcut {
  key: string;
  shift: boolean;
}
